import {useRouter} from 'next/router'
import {useCallback} from 'react'

import {sendClickNlog} from '$utils/nlog'

import type {MouseEventHandler} from 'react'

export const useConnectQueryCheckBack = (nClickCode?: string) => {
    const router = useRouter()

    const handleClick: MouseEventHandler = useCallback(() => {
        const {from, returnUrl} = router.query
        const hasFromConnectQuery = from === 'connect'

        nClickCode && sendClickNlog(nClickCode)
        if (hasFromConnectQuery && typeof returnUrl === 'string') {
            router.push(returnUrl)
        } else {
            router.back()
        }
    }, [router, nClickCode])

    return {handleClick}
}
